import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { loader as gymTermsLoader } from "./pages/gymTermsLoader";
import { loader as landingPageLoader } from "./pages/landingPageLoader";
import SiteLayout from "./layout/SiteLayout";
import HomePage from "./pages/HomePage";
import Notification from "./components/Notification";
import CheckoutModal from "@lemonadetraining/web-shared/components/CheckoutModal";
import CookieNotice from "@lemonadetraining/web-shared/components/CookieNotice";
import { Toaster } from "@lemonadetraining/web-ui";

const gymTermsComponent = async () => {
  const GymTerms = await import("./pages/GymTerms");
  return { Component: GymTerms.default };
};

const router = createBrowserRouter([
  // Landing page — standalone, NO SiteLayout wrapper
  {
    path: "landing-page/:page",
    loader: landingPageLoader,
    async lazy() {
      const LandingPage = await import("./pages/LandingPage");
      return { Component: LandingPage.default };
    },
  },
  // A gym's own terms — public, no account, standalone like the landing page.
  {
    path: "landing-page/:page/terms",
    loader: gymTermsLoader,
    lazy: gymTermsComponent,
  },
  {
    path: "gym-terms/:boxID",
    loader: gymTermsLoader,
    lazy: gymTermsComponent,
  },
  {
    Component: SiteLayout,
    children: [
      {
        path: "payment-status",
        async lazy() {
          const PaymentStatus = await import("./pages/PaymentStatus");
          return { Component: PaymentStatus.default };
        },
      },
      {
        path: "Terms-and-conditions",
        async lazy() {
          const TermsAndCondition = await import("./pages/TermsAndCondition");
          return { Component: TermsAndCondition.default };
        },
      },
      {
        path: "privacy-policy",
        async lazy() {
          const PrivacyPolicy = await import("./pages/PrivacyPolicy");
          return { Component: PrivacyPolicy.default };
        },
      },
      {
        path: "accessibility",
        async lazy() {
          const AccessibilityPage = await import("./pages/AccessibilityPage");
          return { Component: AccessibilityPage.default };
        },
      },
      {
        path: "About-Us",
        async lazy() {
          const AboutUsPage = await import("./pages/AboutUs");
          return { Component: AboutUsPage.default };
        },
      },
      {
        path: "lemonade-business",
        async lazy() {
          const LemonadeBusinessPage = await import("./pages/LemonadeBusinessPage");
          return { Component: LemonadeBusinessPage.default };
        },
      },
      {
        path: "lemonade-coach",
        async lazy() {
          const LemonadeCoachPage = await import("./pages/LemonadeCoachPage");
          return { Component: LemonadeCoachPage.default };
        },
      },
      {
        path: "for-athletes",
        async lazy() {
          const ForAthletesPage = await import("./pages/ForAthletesPage");
          return { Component: ForAthletesPage.default };
        },
      },
      { path: "/", element: <HomePage /> },
      {
        path: "*",
        async lazy() {
          const NotFoundPage = await import("./pages/NotFoundPage");
          return { Component: NotFoundPage.default };
        },
      },
    ],
  },
  {
    path: "forgot-password",
    async lazy() {
      const ForgotPasswordPage = await import("./pages/ForgotPasswordPage");
      return { Component: ForgotPasswordPage.default };
    },
  },
  {
    path: "register",
    async lazy() {
      const SignupPage = await import("./pages/SignupPage");
      return { Component: SignupPage.default };
    },
  },
  {
    path: "login",
    async lazy() {
      const LoginPage = await import("./pages/LoginPage");
      return { Component: LoginPage.default };
    },
  },
  {
    path: "email-preferences",
    async lazy() {
      const EmailPreferencesPage = await import("./pages/EmailPreferencesPage");
      return { Component: EmailPreferencesPage.default };
    },
  },
]);

function App() {
  return (
    <>
      <Toaster position="top-center" richColors closeButton duration={5000} />
      <CheckoutModal />
      <Notification />
      <RouterProvider router={router} />
      {/* New tab: the cart lives in memory, and a reload here would empty it. */}
      <CookieNotice detailsHref="/privacy-policy#cookies" opensInNewTab />
    </>
  );
}

export default App;
